import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import pt from '../i18n/pt';
import en from '../i18n/en';

// Idioma da interface. Precisa persistir entre navegacoes: a Meta reprova o
// video de analise quando a tela volta para portugues ao trocar de pagina.
// Por isso o idioma vive aqui (acima do Router) e nao dentro de cada pagina.

const DICIONARIOS = { pt, en };
const IDIOMAS = [
  { codigo: 'pt', rotulo: 'Portugues', bandeira: 'BR', htmlLang: 'pt-BR' },
  { codigo: 'en', rotulo: 'English', bandeira: 'US', htmlLang: 'en' }
];
const CHAVE_STORAGE = 'chatflow:idioma';
const IDIOMA_PADRAO = 'pt';

const I18nContext = createContext();

function lerIdiomaSalvo() {
  // localStorage lanca em aba anonima com cookies bloqueados.
  try {
    const salvo = window.localStorage.getItem(CHAVE_STORAGE);
    if (salvo && DICIONARIOS[salvo]) return salvo;
  } catch (e) {
    // sem storage: segue com o padrao
  }
  return IDIOMA_PADRAO;
}

export const I18nProvider = ({ children }) => {
  const [idioma, setIdiomaState] = useState(lerIdiomaSalvo);

  // Mantem o <html lang> em sincronia. Alem de acessibilidade, e isso que
  // evita o Chrome oferecer traducao automatica por cima da nossa.
  useEffect(() => {
    const def = IDIOMAS.find((i) => i.codigo === idioma);
    document.documentElement.lang = def ? def.htmlLang : 'pt-BR';
  }, [idioma]);

  const setIdioma = useCallback((codigo) => {
    if (!DICIONARIOS[codigo]) return;
    setIdiomaState(codigo);
    try {
      window.localStorage.setItem(CHAVE_STORAGE, codigo);
    } catch (e) {
      // sem storage: vale so para esta sessao
    }
  }, []);

  // t('chave') devolve o texto. Se faltar no idioma atual cai para o
  // portugues; se faltar nos dois devolve a propria chave, para a falta
  // aparecer na tela em vez de virar espaco em branco.
  const t = useCallback(
    (chave, valores) => {
      const dic = DICIONARIOS[idioma] || DICIONARIOS[IDIOMA_PADRAO];
      let texto = dic[chave];
      if (texto === undefined) texto = DICIONARIOS[IDIOMA_PADRAO][chave];
      if (texto === undefined) return chave;
      if (!valores) return texto;
      return texto.replace(/\{\{(\w+)\}\}/g, (bruto, nome) =>
        valores[nome] === undefined ? bruto : String(valores[nome])
      );
    },
    [idioma]
  );

  return (
    <I18nContext.Provider value={{ idioma, setIdioma, t, idiomas: IDIOMAS }}>
      {children}
    </I18nContext.Provider>
  );
};

export const useI18n = () => {
  const context = useContext(I18nContext);
  if (!context) {
    throw new Error('useI18n must be used within a I18nProvider');
  }
  return context;
};
